module.exports = __webpack_public_path__ + "img/hint_image_gallery_2.b21ff09.svg";